<!-- header -->

<div class="auth-fluid">
    <!--Auth fluid left content -->
    <div class="auth-fluid-form-box">
        <div class="align-items-center d-flex h-100">
            <div class="card-body">
                <!-- Logo -->
                <div class="auth-brand">
                    <img src="assets/images/logo-AA.png" alt="AutoAction Cloud" class="img-fluid" />
                </div>
                @if (image && image.img && image.display) {
                    <div class="d-flex justify-content-center">
                        <img [src]="image.img" alt="" width="300">
                    </div>
                }
                <!-- title-->
                @if (!signUpEnable) {
                    <div class="py-2">
                        <h4 class="mt-0">Sign In</h4>
                        <p class="text-muted mb-2">Enter your email address and password to access your account.</p>
                    </div>
                }
                @if (signUpEnable) {
                    <div class="py-2">
                        <h4 class="mt-0">Free Sign Up</h4>
                        <p class="text-muted mb-2">Create your account, it takes less than a minute.</p>
                    </div>
                }

                @if (!signUpEnable) {
                    <login-form (image$)="listenerChildrens($event)"></login-form>
                }
                @if (signUpEnable) {
                    <register-form></register-form>
                }
                <!-- Footer-->
                <footer class="footer-alt p-3">
                    @if (!signUpEnable) {
                        <p class="text-muted">Don't have an account? <button (click)="signUpEnable=true" class=" ml-1 border-0 bg-transparent text-primary" id="goToSignUp"><b>Sign
                                    Up</b></button></p>
                    }
                    @if (signUpEnable) {
                        <p class="text-muted">Already have an account? <button (click)="signUpEnable=false" class="ml-1 border-0 bg-transparent text-primary" id="goToSignIn"><b>Sign
                                    In</b></button></p>
                    }
                </footer>
            </div> <!-- end .card-body -->
        </div> <!-- end .align-items-center.d-flex.h-100-->
    </div>
    <!-- end auth-fluid-form-box-->

    <!-- Auth fluid right content -->
    <div class="auth-fluid-right text-center">
        <div class="auth-user-testimonial">
            <h1 class="mb-3">Welcome </h1>
            <p class="lead ">Build Your Dealership On A Solid Foundation with AutoAction Cloud.</p>
            <footer class="footer-alt p-1 d-flex align-items-end justify-content-between">
                <p class="text-muted mb-0">© {{currentYear}} AutoAction Cloud All rights reserved.</p>
                <div class="d-flex">
                    <a class="text-muted mx-2 mb-0" [routerLink]="['/privacy']" target="_blank">Privacy </a>
                    <p class="text-muted mx-2 mb-0">Legal</p>
                    <a class="text-muted mx-2 mb-0" [routerLink]="['/contact']" target="_blank">Contact</a>
                </div>
            </footer>
        </div> <!-- end auth-user-testimonial-->
    </div>
    <!-- end Auth fluid right content -->
</div>